import React from 'react'
import LoginImage from "../assets/images/LoginGif.gif"
import { Link } from 'react-router-dom'
import { IoIosArrowBack } from 'react-icons/io'
import Button from '../shared/Button'
import { FilledInput, FormControl, InputAdornment, InputLabel, OutlinedInput } from '@mui/material'
import GoogleLogin from '../components/auth/GoogleLogin'
import GoogleLoginComponent from '../components/auth/GoogleLogin'

const Login = () => {
  const handleGoogleLoginSuccess = (userData) => {
    // Handle the successful Google login
    console.log('Google login success', userData);
    // You can send the user data to your server for authentication.
  };

  const handleGoogleLoginFailure = (error) => {
    // Handle Google login failure
    console.error('Google login failure', error);
  };
  return (
    <div className="min-h-[80vh]">
      <div className='flex justify-center'>
        <div className='flex bg-white rounded-md mt-[8vh] p-4 flex-wrap'>
          <Link to={"/menu"}>
            <span className='h-7 w-7 rounded-full border-light-secondary border-2 bg-gray-100 flex items-center justify-center font-bold cursor-pointer hover:bg-light-secondary text-light-secondary hover:text-white' ><IoIosArrowBack className='font-bold' size={20} /></span>
          </Link>
          <div className='w-[50%] px-12'>
            <img src={LoginImage} alt='Login-Pic' />
          </div>
          <div className='flex flex-col p-10 justify-center gap-3'>
            <h1 className="text-4xl font-bold">Welcome!</h1>

            <FormControl fullWidth variant="filled">
              <InputLabel htmlFor="filled-adornment-amount">Phone Number (3XXXXXXXXX)</InputLabel>
              <FilledInput
                id="filled-adornment-amount"
                startAdornment={<InputAdornment position="start" >
                  <span className='font-bold'>+92</span>
                </InputAdornment>}
              />
            </FormControl>
            <Button type="solid" data="LOGIN" styles="bg-[#E4002B45] flex justify-center text-black" />
            {/* <Button type="solid" data="LOGIN WITH GOOGLE" styles="flex justify-center" /> */}
            <GoogleLoginComponent
              onSuccess={handleGoogleLoginSuccess}
              onFailure={handleGoogleLoginFailure}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
